import React, { useEffect, useState } from "react";
import { Tab, Tabs, Container } from "react-bootstrap";
import UmMappedChargeCodeTable from "./UnMappedChargeCode";
import HideenChargeCode from "./HiddenChargeCode";
import { onExport } from "utils/helper";
import useContextService from "hooks/useContextService";
import useAxios from "hooks/useAxios";

const ChargeCodesTable = (props) => {
  const {
    maping,
    setMaping,
    collapseSider,
    toggleSider,
    chargecodeflag,
    setChargeCodeflag,
    unMappedChargeTableData,
    setUnMappedChargeTableData,
    unmappedChargeTotalrecords,
    unMappedChargecolumnFilters,
    onPageChangeUnMappedCharge,
    handleSearchUnMappedChargeColumnFilters,
    loading,
    setLoading,
    orgId,
    refetchunMappedcharge,
    mapingHistoryData,
    setMapingHistoryData,
    utilizationData,
    setUtilizationData,
    setChargeCodeDetails,
    chargekey,
    setChargekey,
    utilizationDataRecords,
    setUtilizationDataRecords,
    purchaseHistoryinstialValues,
    key,
    selectedutilizationData,
    setSelectedUtilizationData,
    searchChargeCode,
    
    reset2,
    setSearchChargeCode,
    resetFilterFlag,
    SetResetFilterFlag
  } = props;

  const API = useAxios();
  const {
    states: { crosswalkUnmappedcharge },
    setStates,
    resetStates,
  } = useContextService();
  const { unmappedchargesearch } = crosswalkUnmappedcharge;
  const updateStates = (crosswalkUnmappedcharge) => {
    setStates("crosswalkQueue", crosswalkUnmappedcharge);
  };

  const [totalhideRecords, setTotalHideRecords] = useState(0);

  const [reset, setReset] = useState(false);

  // const [unmappedchargodesize, setUnmappedChargeCodeSize] = useState(0)
  const [hiddenchargodesize, sethiddenChargeCodeSize] = useState(0);
  // useEffect(()=>{
  // refetchunMappedcharge(unmappedchargesearch);
  // },[chargekey])
  const onKeyChange = (k) => {
    if (k == 'unmappedChargeCode') {
      refetchunMappedcharge(unmappedchargesearch);
    }
    setChargekey(k);
    setReset(!reset);
    SetResetFilterFlag(true);
  };
  return (
    <>
      <div>
        <div fluid className="bin_info my-0">
          <div
            className=""
          // hidden={collapseSider}
          >
            <div className="card-body p-0">
              <Tabs
                id="controlled-tab-example"
                activeKey={chargekey}
                onSelect={(k) => onKeyChange(k)}
                className="mb-3"
              >
                <Tab
                  eventKey="unmappedChargeCode"
                  title={`${"Unmapped Charge Codes"} ${chargekey === "unmappedChargeCode" ? `(${unmappedChargeTotalrecords})` : ""}`}
                >
                  <UmMappedChargeCodeTable
                    toggleSider={toggleSider}
                    unMappedChargeTableData={unMappedChargeTableData}
                    setUnMappedChargeTableData={setUnMappedChargeTableData}
                    collapseSider={collapseSider}
                    Chargecodeflag={chargecodeflag}
                    setChargeCodeflag={setChargeCodeflag}
                    unMappedChargecolumnFilters={unMappedChargecolumnFilters}
                    onPageChange={onPageChangeUnMappedCharge}
                    onSearchColumnFilters={handleSearchUnMappedChargeColumnFilters}
                    key={key}
                    orgId={orgId}
                    unmappedChargeTotalrecords={unmappedChargeTotalrecords}
                    unmappedchargesearch={unmappedchargesearch}
                    loading={loading}
                    setLoading={setLoading}
                    refetch={refetchunMappedcharge}
                    mapingHistoryData={mapingHistoryData}
                    setMapingHistoryData={setMapingHistoryData}
                    utilizationData={utilizationData}
                    setUtilizationData={setUtilizationData}
                    setChargeCodeDetails={setChargeCodeDetails}
                    utilizationDataRecords={utilizationDataRecords}
                    setUtilizationDataRecords={setUtilizationDataRecords}
                    purchaseHistoryinstialValues={purchaseHistoryinstialValues}
                    selectedutilizationData={selectedutilizationData}
                    setSelectedUtilizationData={setSelectedUtilizationData}
                    resetFilterFlag={resetFilterFlag}
                    SetResetFilterFlag={SetResetFilterFlag}                    
                  />
                </Tab>
                <Tab
                  eventKey="hiddenchargeCodes"
                  title={`Hidden Charge Codes ${chargekey === "hiddenchargeCodes" ? `(${totalhideRecords})` : ""}`}
                >
                  <HideenChargeCode orgId={orgId}
                    loading={loading}
                    setLoading={setLoading}
                    chargekey={chargekey}
                    unmappedchargesearch={unmappedchargesearch}
                    totalhideRecords={totalhideRecords}
                    setTotalHideRecords={setTotalHideRecords}
                    toggleSider={toggleSider}
                    collapseSider={collapseSider}
                    searchChargeCode={searchChargeCode}
                    
                    reset2={reset2}
                    setSearchChargeCode={setSearchChargeCode}
                    resetFilterFlag={resetFilterFlag}
                    SetResetFilterFlag={SetResetFilterFlag}

                  />
                </Tab>
              </Tabs>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChargeCodesTable;
